<template>
  <DocumentList
    document-type="unpublished"
    meta-name="unpublished"
  />
</template>

<script>
import { mapActions } from 'pinia';
import { useAppBase } from '@/stores/app/base';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { useFilters } from '@/stores/filters/filters';
import DocumentList from '../DocumentList.vue';

export default {
  name: 'UnpublishedList',
  components: {
    DocumentList,
  },
  emits: ['track-page-load'],
  mounted() {
    this.showFilterBarSettings({ route: this.$route.name });
    this.$emit('track-page-load', { page: 'Library: Unpublished' });

    if (this.$route.query.closedRedirect) {
      useAppSnackbar().addInfoSnackbar({
        text: 'All unpublished posts will now be in a single library for better search.',
      });
    }

    this.setFilterConfig({
      showMyJobs: true,
    });
  },
  methods: {
    ...mapActions(useAppBase, ['showFilterBarSettings']),
    ...mapActions(useFilters, ['setFilterConfig']),
  },
};
</script>
